const Pagination = require('framework/domain/value/pagination');
const ProjectStatusFactory = require('common/domain/factory/project-status/index');
const ProjectStatusAPI = require('common/infra/api/project-status');

class ProjectStatusCollection extends Backbone.Collection {
    getByProjectID(projectID) {
        const statuses = this.select(projectStatus => {
            return projectStatus.getProjectKey().id === projectID;
        });
        return statuses[0];
    }
}

class ProjectStatusRepository {
    constructor(group) {
        _.extend(this, Backbone.Events);

        this._group = group;
        this._projectStatuses = new ProjectStatusCollection();
        this._factory = new ProjectStatusFactory();
    }

    fetch(inProgress = true, limit = 10, cursor = null) {
        let pagination;

        return ProjectStatusAPI
            .fetchProjectStatusesByGroup(this._group.id, inProgress, limit, cursor)
            .then(data => {
                const results = data.results;
                pagination = new Pagination(
                    data.pagination.totalCount,
                    data.pagination.prevCursor,
                    data.pagination.prevMore,
                    data.pagination.nextCursor,
                    data.pagination.more
                );

                return Promise.all(
                    _.map(results, json => {
                        return this._factory.build(json);
                    })
                );
            })
            .then(projectStatuses=> {
                this.add(projectStatuses);

                return {
                    models: projectStatuses,
                    pagination: pagination
                };
            });
    }

    fetchByProject(project, options = {}) {
        return this.fetchByProjectID(project.id, options);
    }

    fetchByProjectID(projectID, options={}) {
        const projectStatus = this._projectStatuses.getByProjectID(projectID);
        if (projectStatus) {
            return new Promise(resolve => {
                resolve(projectStatus);
            });
        }

        return ProjectStatusAPI
            .fetchByProject(projectID, options)
            .then(data => {
                if (!data) {
                    return null;
                }

                return this._factory.build(data);
            })
            .then(projectStatus => {
                if (!projectStatus) {
                    return null;
                }

                this.add([projectStatus]);
                return projectStatus;
            });
    }

    add(projectStatuses) {
        let targets = _.isArray(projectStatuses) ? projectStatuses : [projectStatuses];
        const addedProjectStatuses = [];
        const updatedProjectStatuses = [];
        _.each(targets, projectStatus => {
            const isNew = ! this._projectStatuses.get(projectStatus.id);
            if (isNew) {
                addedProjectStatuses.push(projectStatus);
            } else {
                updatedProjectStatuses.push(projectStatus);
            }
        });

        this._projectStatuses.add(projectStatuses, { merge: true });

        _.each(addedProjectStatuses, status => { this.trigger('add', status) });
        _.each(updatedProjectStatuses, status => { this.trigger('update', status) });
    }

    delete(projectStatuses) {
        let targets = _.isArray(projectStatuses) ? projectStatuses : [projectStatuses];
        _.each(targets, projectStatus => {
            this._projectStatuses.remove(projectStatus.id);
            this.trigger('remove', projectStatus.id);
        });
    }

    deleteByProjectID(projectID) {
        const projectStatus = this._projectStatuses.getByProjectID(projectID);
        if (!projectStatus) {
            return;
        }
        this.delete(projectStatus);
    }
}

const repositories = {};

const find = (group) => {
    let r = repositories[group.id];
    if (!r) {
        r = new ProjectStatusRepository(group);
        repositories[group.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./common/domain/repository/project-status.js